import React from 'react';
import classnames from 'classnames';

export default class CompanySelect extends React.Component {
    componentDidMount() {
        const {
            companiesLoading,
            companiesLoaded,
            loadCompanies
        } = this.props;

        if ( !companiesLoading && !companiesLoaded ) {
            loadCompanies();
        }
    }

    render() {
        const {
            companies,
            value,
            onChange,
            className
        } = this.props;
        const classes = classnames( className );
        return (
            <select
                className={ classes }
                value={ value || '' }
                onChange={ onChange }
            >
            <option value=""></option>
            {
                companies.map( ( company ) =>
                    <option key={ company.id } value={ company.id }>{ company.name }</option>
                )
            }
            </select>
        );
    }
}
